/**
 * Módulo para Generación de Referencias BBVA (Bancomer) - Algoritmo 46
 * Estructura de 20 posiciones: Plantel (2) + Conceptos (10) + Consecutivo (5) + Dig. Importe (1) + M97 (2)
 */

export const generarReferenciaBBVA = (plantel, conceptos, matricula, monto) => {
    
    // 1. Extraer Plantel (2 posiciones)
    const strPlantel = String(plantel).padStart(2, "0");

    // 2. Armar Conceptos (10 posiciones)
    // Se unen las claves y se rellenan con "0" a la derecha si son menos de 5 conceptos.
    const strConceptos = conceptos.join("").padEnd(10, "0").substring(0, 10); 

    // 3. Extraer Consecutivo de la matrícula (5 posiciones)
    const consecutivo = String(matricula).padStart(14, "0").substring(9, 14);

    // 4. Armar Referencia Base (17 posiciones exactas)
    // Acomodo: Plantel + Conceptos + Consecutivo
    const baseReferencia = `${strPlantel}${strConceptos}${consecutivo}`;

    // 5. Calcular dígito verificador del importe (Factores 7, 3, 1)
    const importeCentavos = Math.round(Number(monto) * 100).toString();
    const ponderadoresImp = [7, 3, 1];
    let sumaImp = 0;
    let idxImp = 0;
    
    for (let i = importeCentavos.length - 1; i >= 0; i--) {
        sumaImp += parseInt(importeCentavos[i], 10) * ponderadoresImp[idxImp % 3];
        idxImp++;
    }
    const digitoImp = (sumaImp % 10).toString();

    // 6. Calcular dígitos verificadores M97 (Factores 11, 13, 17, 19, 23)
    const cadenaM97 = baseReferencia + digitoImp; // 17 de base + 1 de importe = 18 posiciones
    
    const ponderadoresM97 = [11, 13, 17, 19, 23];
    let sumaM97 = 0;
    let idxM97 = 0;
    
    for (let i = cadenaM97.length - 1; i >= 0; i--) {
        sumaM97 += parseInt(cadenaM97[i], 10) * ponderadoresM97[idxM97 % 5];
        idxM97++;
    }
    const digitosM97 = ((sumaM97 % 97) + 1).toString().padStart(2, '0');

    // 7. Ensamblar línea de captura final (Exactamente 20 posiciones)
    const lineaDeCaptura = `${baseReferencia}${digitoImp}${digitosM97}`;

    return {
        lineaDeCaptura,
        referenciaBase: baseReferencia,
        montoTotal: Number(monto).toFixed(2)
    };
};